import React from "react";

interface LogoProps {
  className?: string;
  showOnlyOnMobile?: boolean;
  showOnlyOnDesktop?: boolean;
}

const Logo: React.FC<LogoProps> = ({
  className = "h-[40px]",
  showOnlyOnMobile = false,
  showOnlyOnDesktop = false,
}) => {
  const visibilityClass = showOnlyOnMobile
    ? "md:hidden"
    : showOnlyOnDesktop
    ? "hidden md:block"
    : "";

  return (
    <div className={`${visibilityClass} ${className}`}>
      <img
        src={process.env.PUBLIC_URL + "/images/mim-logo.png"}
        alt="MiM logo"
        className="h-full"
      />
    </div>
  );
};

export default Logo;
